// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Virtualized Vertical Grid for Single View */
/* Uses external scroll container (lobbyContainer) for scrolling */
.WUi0kMcCt8uLoh_OMRlG {
  width: 100%;
  /* No overflow - parent lobbyContainer handles scrolling */
  height: fit-content;
}
.qO1v46g1cShPKsNCCggK {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--grid-gap);
  justify-items: center;
  align-items: start;
  width: 100%;
  box-sizing: border-box;
  /* Ensure rows have proper height based on content */
  min-height: fit-content;
}
.InJYIma7H6kjBug59vZJ {
  width: 100%;
  display: flex;
  justify-content: center;
}
.ZBx3mD8MFzuBLE_sqNFT {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 20px;
}
/* Responsive column layouts matching GameGrid.module.css */
@media (min-width: 389px) {
  .qO1v46g1cShPKsNCCggK {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 576px) {
  .qO1v46g1cShPKsNCCggK {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1026px) {
  .qO1v46g1cShPKsNCCggK {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1280px) {
  .qO1v46g1cShPKsNCCggK {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1600px) {
  .qO1v46g1cShPKsNCCggK {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/VirtualizedGrid/ReactVirtualVerticalGrid.module.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,kEAAkE;AAClE;EACE,WAAW;EACX,0DAA0D;EAC1D,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,oDAAoD;EACpD,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;AACf;AACA,2DAA2D;AAC3D;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,4DAA4D;EAC9D;AACF","sourcesContent":["/* Virtualized Vertical Grid for Single View */\n/* Uses external scroll container (lobbyContainer) for scrolling */\n.virtualizedContainer {\n  width: 100%;\n  /* No overflow - parent lobbyContainer handles scrolling */\n  height: fit-content;\n}\n.virtualRow {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: var(--grid-gap);\n  justify-items: center;\n  align-items: start;\n  width: 100%;\n  box-sizing: border-box;\n  /* Ensure rows have proper height based on content */\n  min-height: fit-content;\n}\n.gameCell {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.emptyContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 20px;\n}\n/* Responsive column layouts matching GameGrid.module.css */\n@media (min-width: 389px) {\n  .virtualRow {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (min-width: 576px) {\n  .virtualRow {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n@media (min-width: 1026px) {\n  .virtualRow {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n@media (min-width: 1280px) {\n  .virtualRow {\n    grid-template-columns: repeat(6, 1fr);\n  }\n}\n@media (min-width: 1600px) {\n  .virtualRow {\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"virtualizedContainer": `WUi0kMcCt8uLoh_OMRlG`,
	"virtualRow": `qO1v46g1cShPKsNCCggK`,
	"gameCell": `InJYIma7H6kjBug59vZJ`,
	"emptyContainer": `ZBx3mD8MFzuBLE_sqNFT`
};
export default ___CSS_LOADER_EXPORT___;
